import { DEFAULT_PASTE_ATTACHMENT_THRESHOLD_BYTES } from '@/features/chat/utils/paste-guard';

// Fallback status shown while waiting for the first SSE event
export const STATUS_MESSAGES = ['Thinking...'];
export const ENABLE_LOCAL_VIEW_INTENT_FAST_PATH =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_VIEW_INTENT_FAST_PATH === 'true';
export const ENABLE_EMBEDDED_MODULE_PANE_DEFAULT = true;
export const EMBEDDED_MODULE_PANE_QUERY_KEY = 'embedModulePane';

/**
 * Threshold above which a plain-text paste becomes a collapsed attachment
 * chip instead of being inlined into the textarea. Below this, pasting
 * behaves normally (default browser insert).
 *
 * Raising this increases the chance a large HTML block gets inlined and
 * blows the prompt-assembler context budget (the diagnostic pass traced
 * this to "Opened it." / "Done." no-op replies). Lowering it creates chip
 * noise for small quoted snippets. 4096 bytes ≈ ~600 words of prose or
 * a small HTML section — the sweet spot. The decision logic itself
 * lives in `paste-guard.ts` so it's unit-testable without mounting the
 * full composer.
 */
export const PASTE_ATTACHMENT_THRESHOLD_BYTES = DEFAULT_PASTE_ATTACHMENT_THRESHOLD_BYTES;
export const EMBEDDED_MODULE_PANE_STORAGE_KEY = 'xavior:embed-module-pane';
export const QUOTA_WARN_DISMISS_KEY = 'xavior:quota-warn-dismissed';

export const VIEW_OPEN_ACK_TEMPLATES = [
  'Opening {view}.',
  'Bringing up {view}.',
  'Pulling up {view} now.',
  'Loading {view} for you.',
  'Switching over to {view}.',
  'Moving to {view}.',
  'Taking you to {view}.',
  'Got it, showing {view}.',
  '{view} is coming up.',
  'Launching {view}.',
  'Now opening {view}.',
  'Displaying {view}.',
  'Routing you to {view}.',
  'Jumping to {view}.',
  'Putting {view} on screen.',
  'Bringing {view} into focus.',
  'Opening up {view}.',
  'Showing {view} now.',
];

export const VIEW_CREATE_ACK_TEMPLATES = [
  'Creating {view} and opening it.',
  'No {view} yet, creating it now.',
  'Setting up {view} and bringing it up.',
  'I will create {view} and open it.',
  'Creating {view} so you can use it now.',
  'Building a new {view} now.',
  'Spinning up {view} and opening it.',
  'Preparing {view} and loading it.',
  'Making a {view} for you now.',
  'Creating {view}, then switching to it.',
];
